define('controllers/login',[],function() {
    return function() {
        $(function () {
            if (!CookieUtil.supportingCookies()) {
                $("#cookiesDisabled").show();
            }

            if (window.ServerData.feData.UserBeingProcessed) {
                $("#anchorUserBeingProcessed").fancybox({
                    autoSize: true,
                    maxWidth: 450
                }).trigger('click');
            }
        });
    };
});
